import { Action } from '@ngrx/store';
import { User } from '../models/user';

export enum AppActionTypes {
  ToggleCurrentUser = '[App] Toggle Current User'
}

export class ToggleCurrentUser implements Action {
  readonly type = AppActionTypes.ToggleCurrentUser;

  constructor(public payload: User) { }
}

export type AppActions = ToggleCurrentUser;
